// extracted by mini-css-extract-plugin
export default {"media_nav":"styles_media_nav__puo2z","media_nav_icon":"styles_media_nav_icon__FJkCN","media_nav_contact":"styles_media_nav_contact__R9s9d"};